var _defs, _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnalyticBarchart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79 81",
    width: 79,
    height: 81,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "barchart-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 63.1,
    y1: 68.8,
    x2: 62.8,
    y2: 49.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2cc0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 34.1,
    y1: 68.7,
    x2: 33.3,
    y2: 24.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2cc0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x1: 4.1,
    y1: 67.1,
    x2: 4.6,
    y2: 8.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2cc0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9830"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #3865ab } \r\n\t\t.s1 { fill: url(#g1) } \r\n\t\t.s2 { fill: url(#g2) } \r\n\t\t.s3 { fill: url(#g3) } \r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m69.8 34.9c0-0.5 0.5-1 1-1h6.8c0.5 0 1 0.5 1 1v36.3c0 0.6-0.5 1-1 1h-6.8c-0.5 0-1-0.4-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m40.5 40.5c0-0.6 0.5-1 1-1h6.8c0.5 0 1 0.4 1 1v30.7c0 0.6-0.5 1-1 1h-6.8c-0.5 0-1-0.4-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m0 77.4c0-0.5 0.4-1 1-1h76.6c0.5 0 1 0.5 1 1v2c0 0.6-0.5 1-1 1h-76.6c-0.6 0-1-0.4-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m11.2 10.1c0-0.5 0.5-1 1-1h6.8c0.5 0 1 0.5 1 1v61.1c0 0.6-0.5 1-1 1h-6.8c-0.5 0-1-0.4-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m58.6 49c0-0.6 0.5-1 1-1h6.8c0.5 0 1 0.4 1 1v22.2c0 0.6-0.5 1-1 1h-6.8c-0.5 0-1-0.4-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m29.3 21.1c0-0.6 0.5-1 1-1h6.8c0.5 0 1 0.4 1 1v50.1c0 0.6-0.5 1-1 1h-6.8c-0.5 0-1-0.4-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m0 1c0-0.6 0.5-1 1-1h6.7c0.6 0 1 0.4 1 1v70.2c0 0.6-0.4 1-1 1h-6.7c-0.5 0-1-0.4-1-1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticBarchart);
export default __webpack_public_path__ + "static/media/analytic-barchart.741cfb40ab6d4f0de27c6ac54c34967d.svg";
export { ForwardRef as ReactComponent };